const InfoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#0252A7" fill-opacity="0.15" />
      <path
        d="M11.1499 17.5V8.77273H12.8487V17.5H11.1499ZM12.0078 7.42614C11.7124 7.42614 11.4586 7.32765 11.2464 7.13068C11.0381 6.92992 10.9339 6.69129 10.9339 6.41477C10.9339 6.13447 11.0381 5.89583 11.2464 5.69886C11.4586 5.49811 11.7124 5.39773 12.0078 5.39773C12.3033 5.39773 12.5552 5.49811 12.7635 5.69886C12.9756 5.89583 13.0817 6.13447 13.0817 6.41477C13.0817 6.69129 12.9756 6.92992 12.7635 7.13068C12.5552 7.32765 12.3033 7.42614 12.0078 7.42614Z"
        fill="#0252A7"
      />
    </svg>
  );
};

export default InfoIcon;
